var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import Text from 'elements/Text';
class CountUp extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            value: this.props.to
        };
        this.increment = (from, to, duration, end) => {
            const now = Date.now();
            const step = (to - from) / duration * -(end - now - duration);
            if (Date.now() < end) {
                // this.state.value = from + step
                this.setState({ value: from + step });
                requestAnimationFrame(() => this.increment(from, to, duration, end));
            }
            else
                // this.state.value = to
                this.setState({ value: to });
        };
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.to !== nextProps.to) {
            const duration = this.props.duration || 400;
            const from = this.state.value;
            const to = nextProps.to;
            this.increment(from, to, duration, Date.now() + duration);
        }
    }
    render() {
        const _a = this.props, { to, duration } = _a, props = __rest(_a, ["to", "duration"]);
        const { value } = this.state;
        return (React.createElement(Text, Object.assign({}, props, { lines: 1, primary: props.primary }), value));
    }
}
export default CountUp;



//////////////////
// WEBPACK FOOTER
// ./src/components/CountUp.tsx
// module id = 556
// module chunks = 0